window.initLookModal = (root) => {
  const modalElem = root.querySelector(".shop-the-look__modal-container");
  if (!modalElem) return null;

  const modalSlider = modalElem.querySelector(".shop-the-look__modal-slider");
  const productWrappers = [...modalElem.querySelectorAll(".buyable-product-wrapper")];
  const openClassName = "shop-the-look__modal-container--open";
  const closeButtonSelector = ".shop-the-look__modal-close-button";
  const scrollBoxSelector = ".shop-the-look__modal-item, .shop-the-look__modal-item-content-container";

  let modalSplide;
  const photoSplides = new Map();
  const shownSinceOpen = new Set();
  let releaseFocus = null;

  const mountPhotoSplides = (wrapper) =>
    [...wrapper.querySelectorAll(".splide")].map((slider) =>
      new Splide(slider, {
        type: "loop",
        pagination: false,
        arrows: true,
        height: "100%",
        drag: true,
        snap: true,
        waitForTransition: true,
      }).mount(),
    );

  const showFromTheTop = (wrapper) => {
    if (shownSinceOpen.has(wrapper)) return;
    shownSinceOpen.add(wrapper);
    const mounted = photoSplides.get(wrapper);
    if (mounted) {
      wrapper.querySelectorAll(scrollBoxSelector).forEach((box) => box.scrollTo(0, 0));
      mounted.forEach((splide) => splide.destroy());
    }
    photoSplides.set(wrapper, mountPhotoSplides(wrapper));
  };

  const showItem = (index) => {
    if (!modalSplide) {
      modalSplide = new Splide(modalSlider, {
        type: "fade",
        arrows: false,
        start: index,
        drag: false,
        pagination: false,
      }).mount();
      return;
    }
    const { Controller, Slides } = modalSplide.Components;
    Controller.setIndex(index);
    Slides.style("transition", "none");
    Slides.update();
  };

  const open = (productId) => {
    if (releaseFocus) return;
    window.freezeDocumentHeight();

    const index = Math.max(
      productWrappers.findIndex((wrapper) => wrapper.dataset.productId == productId),
      0,
    );
    showItem(index);
    modalElem.classList.add(openClassName);
    modalElem.removeAttribute("inert");

    shownSinceOpen.clear();
    showFromTheTop(productWrappers[index]);
    releaseFocus = window.holdOverlayFocus(modalElem, productWrappers[index].querySelector(closeButtonSelector), () => close());
  };

  const close = () => {
    window.unfreezeDocumentHeight();
    modalElem.classList.remove(openClassName);
    modalElem.setAttribute("inert", "true");
    releaseFocus?.();
    releaseFocus = null;
  };

  const switchItem = (button, direction, sameButtonSelector) => {
    if (!modalSplide) return;
    modalSplide.go(direction);
    showFromTheTop(productWrappers[modalSplide.index]);
    if (document.activeElement !== button) return;
    const item = productWrappers[modalSplide.index];
    const sameButton = item.querySelector(sameButtonSelector);
    (sameButton && !sameButton.disabled ? sameButton : item.querySelector(closeButtonSelector)).focus();
  };

  modalElem.addEventListener("click", (ev) => {
    if (ev.target == modalElem) close();
  });
  modalElem.querySelectorAll(closeButtonSelector).forEach((button) => {
    button.addEventListener("click", () => close());
  });
  modalElem.querySelectorAll(".shop-the-look__switch-product-button--next").forEach((button) => {
    button.addEventListener("click", () => switchItem(button, ">", ".shop-the-look__switch-product-button--next"));
  });
  modalElem.querySelectorAll(".shop-the-look__switch-product-button--prev").forEach((button) => {
    button.addEventListener("click", () => switchItem(button, "<", ".shop-the-look__switch-product-button--prev"));
  });

  modalElem.querySelectorAll(".shop-the-look__modal-accordion-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      trigger.setAttribute("aria-expanded", !isOpen);
      trigger.nextElementSibling.classList.toggle("shop-the-look__modal-accordion-content--open", !isOpen);
    });
  });

  productWrappers.forEach((wrapper) => {
    window.updateProductPurchaseDetails(wrapper);
    window.bindAddToCart(wrapper);
  });

  return { open };
};
